<template>
  <div id="contact">
    <img :src="require('@/assets/top-divider.png')" alt="Flowing divider" class="bg-secondary w-100"/>
    <div class="bg-secondary">
      <div class="container py-5">
        <div class="bg-light shadow rounded-3">
          <form @submit.stop.prevent="onSubmit"
                class="px-3 py-4 py-md-5 px-md-5 d-flex flex-column justify-content-center">
            <h2 class="fw-bolder text-center mb-3">{{ $t('contact.header') }}</h2>
            <div class="form-floating">
              <input type="text"
                     class="form-control text-muted"
                     placeholder="Name"
                     id="floatingInputName"
                     v-model="$v.name.$model"
                     :state="validateState('name')"
              />
              <label htmlFor="floatingInputGrid" class="text-muted">{{ $t('contact.form_name') }}</label>
            </div>
            <div class="invalid-feedback" v-bind:class="$v.name.$anyError && $v.name.$dirty && 'd-block'">
              {{ $t('contact.form_name_invalid') }}
            </div>
            <div class="form-floating mt-3">
              <input type="text"
                     class="form-control text-muted"
                     placeholder="Email"
                     id="floatingInputEmail"
                     v-model="$v.email.$model"
                     :state="validateState('email')"
              />
              <label htmlFor="floatingInputGrid" class="text-muted">{{ $t('contact.form_email') }}</label>
            </div>
            <div class="invalid-feedback" v-bind:class="$v.email.$anyError && $v.email.$dirty && 'd-block'">
              {{ $t('contact.form_email_invalid') }}
            </div>
            <div class="form-floating mt-3">
            <textarea class="form-control text-muted"
                      placeholder="Message"
                      id="floatingTextarea"
                      v-model="$v.message.$model"
                      :state="validateState('message')"
            ></textarea>
              <label htmlFor="floatingTextarea" class="text-muted">{{ $t('contact.form_message') }}</label>
            </div>
            <div class="invalid-feedback" v-bind:class="$v.message.$anyError && $v.message.$dirty && 'd-block'">
              {{ $t('contact.form_message_invalid') }}
            </div>
            <div class="d-grid mt-3">
              <button class="btn btn-outline-primary rounded-pill" v-on:click="this.onSubmit">
                {{ $t('contact.form_button') }}
              </button>
            </div>
            <div v-if="show_alert" class="alert alert-dismissible fade show mt-4 mb-0"
                 v-bind:class="[alert_success ? 'alert-success' : 'alert-danger']" role="alert" ref="alert">
              {{ alert_message }}
              <button type="button" class="btn-close btn-sm" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {validationMixin} from "vuelidate";
import {required, minLength, email} from "vuelidate/lib/validators";

export default {
  name: 'Contact',
  mixins: [validationMixin],
  data() {
    return {
      email: '',
      name: '',
      message: '',
      show_alert: false,
      alert_success: false,
      alert_message: this.$t('contact.alert_success')
    }
  },
  validations: {
    email: {
      required,
      email
    },
    name: {
      required,
      minLength: minLength(3)
    },
    message: {
      required,
      minLength: minLength(10)
    }
  },
  methods: {
    validateState(name) {
      const {$dirty, $error} = this.$v[name];
      return $dirty ? !$error : null;
    },

    onSubmit() {
      this.$v.name.$touch();
      if (this.$v.$anyError) {
        return;
      }
      this.$http.post(this.$contact_url, {
        name: this.name,
        email: this.email,
        message: this.message,
        target: 'VILROSA'
      })
          .then(() => {
            this.alert_message = this.$t('contact.alert_success');
            this.alert_success = true;
            this.show_alert = true;
          })
          .catch(() => {
            this.alert_message = this.$t('contact.alert_error');
            this.alert_success = false;
            this.show_alert = true;
          })
    }
  }
}
</script>

<style scoped>
#contact {
  padding-top: 77px;
}

.is-invalid {
  border: 0;
}
</style>
